if(!customElements.get('faq-accordion')) {
  class ComponentFaqAccordion extends HTMLElement {
    constructor() {
      super();
      var accordions = this.querySelectorAll('.accordion');
      accordions.forEach( accordion => {
        var expand = accordion.querySelector(".expand");
        var description = accordion.querySelector(".description");

        expand.addEventListener('click', (e) => {
          $s.toggle(description);
          if(expand.classList.contains("active")){
            expand.classList.remove("active");
          } else {
            expand.classList.add("active");
          }
        });
      })
      

    }

    

  }
  customElements.define('faq-accordion', ComponentFaqAccordion);
}